import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*
* Stair 階段部品
*
* new AutoStair( 0,1,null,"",0,0,0);
*/
export default class AutoObjStair {
    public index: number;

    public guid: string;

    public flr: number;

    public p: marietta.core.Point;

    public item: string;

    public rotation: number;

    public width: number;

    public depth: number;

    public type: number;

    public id3D: string;

    public reverse: boolean;

    public stroke: marietta3d.AutoGen.utils.RoomPointArray;

    constructor(index: number, cindex: string, flr: number, p: marietta.core.Point, item: string, rot: number, wid: number, dep: number, pAry: marietta3d.AutoGen.utils.RoomPointArray) {
      this.index = index;
      this.guid = cindex;
      this.flr = flr;
      this.p = p;
      this.item = item;
      this.rotation = rot;
      this.width = wid;
      this.depth = dep;
      this.type = 0;
      this.id3D = '';
      this.reverse = false;
      this.stroke = new marietta3d.AutoGen.utils.RoomPointArray();
      if (pAry != null) {
        this.stroke.CopyFrom(pAry);
      }
    }

    /*
    * 描画
    *
    */
    public draw(sc: marietta3d.AutoGen.Scale, ctx: CanvasRenderingContext2D): void {
      const clBlue = '#00a';
      const cl = clBlue;
      ctx.beginPath();
      ctx.fillStyle = cl;
      ctx.lineWidth = 1;
      const ip1 = sc.ConvertToCanvas(this.stroke[0]);
      ctx.moveTo(ip1.x, ip1.y);
      for (let i = 1; i < this.stroke.length; i += 1) {
        const ip2 = sc.ConvertToCanvas(this.stroke[i]);
        ctx.lineTo(ip2.x, ip2.y);
      }
      ctx.closePath();
      ctx.fill();
    }

    /*
    * Hit test
    *
    */
    public IsHit(mp: marietta.core.Point): boolean {
      if (this.stroke.IsInclude(mp) === marietta3d.AutoGen.utils.RC_INCLUDE.INSIDE) {
        return true;
      }
      return false;
    }

    /*
    * Move
    *
    */
    public Move(x: number, y: number): void {
      this.stroke.Move(x, y);
      this.p.x += x;
      this.p.y += y;
    }

    /*
    * XML
    *
    */
    public createXML(/* cnt: number, sc: marietta3d.AutoGen.Scale */): string {
      const { width } = this;
      const { depth } = this;
      const lr = (this.reverse === true) ? '1' : '0';
      let xml: string = '';
      xml = `${xml}<item id="${this.item}" f="${this.flr.toString()}" index="${this.index.toString()}" guid="${this.guid}"`;
      xml = `${xml} x="${this.p.x.toString()}" y="${this.p.y.toString()}"`;
      xml = `${xml} width="${width.toString()}" depth="${depth.toString()}"`;
      xml = `${xml} rotation="${this.rotation.toString()}" lr="${lr}" idthreed="${this.id3D}">\n`;
      xml += ' <shape>\n';
      for (let i = 0; i < this.stroke.length; i += 1) {
        const p = this.stroke[i];
        const num = (i + 1).toString();
        xml = `${xml}  <point wall_type="${p.flag.toString()}" index="${num}" x="${p.x.toString()}" y="${p.y.toString()}"/>\n`;
      }
      xml += ' </shape>\n';
      xml += '</item>\n';
      return xml;
    }

    /*
    * XML
    *
    */
    public createXML2(doc: Document, node: Element/* , cnt: number, sc: marietta3d.AutoGen.Scale */): void {
      const { width } = this;
      const { depth } = this;
      const lr: string = (this.reverse === true) ? '1' : '0';
      const nodeItem = doc.createElement('item');
      node.appendChild(nodeItem);
      nodeItem.setAttribute('id', this.item);
      nodeItem.setAttribute('f', this.flr.toString());
      nodeItem.setAttribute('index', this.index.toString());
      nodeItem.setAttribute('guid', this.guid);
      nodeItem.setAttribute('x', this.p.x.toString());
      nodeItem.setAttribute('y', this.p.y.toString());
      nodeItem.setAttribute('width', width.toString());
      nodeItem.setAttribute('depth', depth.toString());
      nodeItem.setAttribute('rotation', this.rotation.toString());
      nodeItem.setAttribute('lr', lr);
      nodeItem.setAttribute('idthreed', this.id3D);
      const nodeShape = doc.createElement('shape');
      nodeItem.appendChild(nodeShape);
      for (let i = 0; i < this.stroke.length; i += 1) {
        const p = this.stroke[i];
        const num = (i + 1).toString();
        const nodeP = doc.createElement('point');
        nodeShape.appendChild(nodeP);
        nodeP.setAttribute('index', num);
        nodeP.setAttribute('x', p.x.toString());
        nodeP.setAttribute('y', p.y.toString());
        nodeP.setAttribute('wall_type', p.flag.toString());
      }
    }

    /*
    * XML
    *
    */
    public readXML(item: any/* , sc: marietta3d.AutoGen.Scale */): void {
      const rattr = item.attributes;
      this.flr = Number(rattr.getNamedItem('f').nodeValue);
      this.index = Number(rattr.getNamedItem('index').nodeValue);
      this.item = rattr.getNamedItem('id').nodeValue;
      const nodeGuid = rattr.getNamedItem('guid');
      if (nodeGuid != null) {
        this.guid = nodeGuid.nodeValue;
      } else {
        this.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      const enlr = rattr.getNamedItem('lr');
      if (enlr != null) {
        const wlr = enlr.nodeValue;
        this.reverse = (wlr === '1');
      }
      const x: number = Number(rattr.getNamedItem('x').nodeValue);
      const y: number = Number(rattr.getNamedItem('y').nodeValue);
      this.p = new marietta.core.Point(x, y, 0);
      this.rotation = Number(rattr.getNamedItem('rotation').nodeValue);
      const width: number = Number(rattr.getNamedItem('width').nodeValue);
      const depth: number = Number(rattr.getNamedItem('depth').nodeValue);
      this.width = width;
      this.depth = depth;
      const item3d = rattr.getNamedItem('idthreed');
      if (item3d != null) {
        this.id3D = item3d.nodeValue;
      }
      if (this.id3D === 'null') {
        this.id3D = '';
      }
      // shape
      const shape = item.getElementsByTagName('shape');
      if (shape.length > 0) {
        const points = shape[0].getElementsByTagName('point');
        for (let j = 0; j < points.length; j += 1) {
          const pt = points[j].attributes;
          const ptx: number = Number(pt.getNamedItem('x').nodeValue);
          const pty: number = Number(pt.getNamedItem('y').nodeValue);
          const ptf: number = Number(pt.getNamedItem('wall_type').nodeValue);
          this.stroke.Add(new marietta.core.Point(ptx, pty, ptf));
        }
      }
    }

    /*
    * Json
    *
    */
    public readJson(item: any/* , sc: marietta3d.AutoGen.Scale */): void {
      this.flr = Number(item.f);
      this.index = Number(item.index);
      this.item = item.id;
      const nodeGuid = item.guid;
      if (nodeGuid != null) {
        this.guid = nodeGuid;
      } else {
        this.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      const enlr = item.lr;
      if (enlr != null) {
        const wlr = enlr;
        this.reverse = (wlr === '1');
      }
      const x: number = Number(item.x);
      const y: number = Number(item.y);
      this.p = new marietta.core.Point(x, y, 0);
      this.rotation = Number(item.rotation);
      const width: number = Number(item.width);
      const depth: number = Number(item.depth);
      this.width = width;
      this.depth = depth;
      const item3d = item.idthreed;
      if (item3d != null) {
        this.id3D = item3d;
      }
      if (this.id3D === 'null') {
        this.id3D = '';
      }
      // shape
      const shapeData = item.shape;
      if (shapeData.length > 0) {
        for (let j = 0; j < shapeData.length; j += 1) {
          const ptx: number = Number(shapeData[j].x);
          const pty: number = Number(shapeData[j].y);
          const ptf: number = Number(shapeData[j].wall_type);
          this.stroke.Add(new marietta.core.Point(ptx, pty, ptf));
        }
      }
    }
}
